import React from 'react'
import { useTranslation } from 'react-i18next'
import { useNavigationStore } from '@/stores/navigation'

const Accessibility: React.FC = () => {
  const { t } = useTranslation()
  const navigationStore = useNavigationStore()

  const handleContactClick = () => {
    navigationStore.openContactModal()
  }

  return (
    <div className="min-h-screen bg-white">
      {/* Hero Section */}
      <section className="bg-gradient-to-br from-blue-900 to-blue-800 text-white py-16">
        <div className="max-w-4xl mx-auto px-6">
          <h1 className="text-4xl md:text-5xl font-bold mb-6">
            {t('accessibility.title')}
          </h1>
          <p className="text-xl text-blue-100 leading-relaxed">
            {t('accessibility.subtitle')}
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-16">
        <div className="max-w-4xl mx-auto px-6">
          <div className="prose prose-lg max-w-none">
            {/* Commitment Section */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-6">
                {t('accessibility.commitment.title')}
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed mb-6">
                {t('accessibility.commitment.description')}
              </p>
              <p className="text-lg text-slate-700 leading-relaxed">
                {t('accessibility.commitment.standards')}
              </p>
            </div>

            {/* Ongoing Efforts */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-6">
                {t('accessibility.ongoing.title')}
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed">
                {t('accessibility.ongoing.description')}
              </p>
            </div>

            {/* Feedback Section */}
            <div className="mb-12">
              <h2 className="text-3xl font-bold text-slate-900 mb-6">
                {t('accessibility.feedback.title')}
              </h2>
              <p className="text-lg text-slate-700 leading-relaxed mb-6">
                {t('accessibility.feedback.description')}
              </p>
              
              <div className="bg-blue-50 border-l-4 border-blue-500 p-6 rounded-lg">
                <h3 className="text-xl font-semibold text-slate-900 mb-4">
                  {t('accessibility.feedback.contactTitle')}
                </h3>
                <div className="space-y-3">
                  <div className="flex items-center">
                    <span className="text-2xl mr-3">📧</span>
                    <div>
                      <span className="font-medium text-slate-900">Email: </span>
                      <a 
                        href="mailto:management@eceptionist.com"
                        className="text-blue-600 hover:text-blue-800 underline"
                      >
                        management@eceptionist.com
                      </a>
                    </div>
                  </div>
                  <div className="flex items-center">
                    <span className="text-2xl mr-3">📞</span>
                    <div>
                      <span className="font-medium text-slate-900">Phone: </span>
                      <a 
                        href="tel:713-520-6688"
                        className="text-blue-600 hover:text-blue-800 underline"
                      >
                        713-520-6688
                      </a>
                    </div>
                  </div>
                </div>
                <p className="text-slate-700 mt-4">
                  {t('accessibility.feedback.commitment')}
                </p>
              </div>
            </div>

            {/* Contact Button */}
            <div className="text-center">
              <button
                onClick={handleContactClick}
                className="inline-flex items-center px-8 py-4 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-lg transition-colors duration-200 focus:outline-none focus:ring-4 focus:ring-green-300"
              >
                {t('accessibility.contactButton')}
              </button>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default Accessibility
